export default {
  TELEPHONY: 'Telephony',
  ONLINE: 'Online'
};
